import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import store from './stateStore';
// import { useAppDispatch, useTypedSelector } from './stateStore';
import { NavigationServices } from './reducers/NavigationSlice';
import { PagesServices } from './reducers/PagesSlice';
import { QuotesServices } from './reducers/QuotesSlice';
import { SkillServices } from './reducers/SkillSlice';
import { SkillHierarchyServices } from './reducers/SkillHierarchySlice';
import { ExperienceServices } from './reducers/ExperienceSlice';
import { ProjectsServices } from './reducers/ProjectsSlice';
import { CertificationsServices } from './reducers/CertificationsSlice';

store.dispatch(SkillServices.getSkill())
store.dispatch(SkillHierarchyServices.getSkillHierarchy())
store.dispatch(ExperienceServices.getExperience())
store.dispatch(NavigationServices.getNavigation())
store.dispatch(PagesServices.getPages())
store.dispatch(QuotesServices.getQuotes())
store.dispatch(ProjectsServices.getProjects())
store.dispatch(CertificationsServices.getCertifications())

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// reportWebVitals();
